import { Button } from "primereact/button";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import UpdateUserForm from "./UpdateUserForm";

function UpdateUser({ data, getAllUsers, companyId }) {
  const [showModal, setShowModal] = useState(false);
  if (data === null) {
    return null;
  }
  const onCloseModal = () => {
    setShowModal(false);
  };
  return (
    <>
      <Button
        icon="pi pi-pencil"
        onClick={() => setShowModal(true)}
        className="p-button-rounded p-button-warning p-mr-2"
      />
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        <UpdateUserForm
          formData={data}
          onCloseModal={onCloseModal}
          getAllUsers={getAllUsers}
          companyId={companyId}
        />
      </Dialog>
    </>
  );
}

export default UpdateUser;
